module.exports = __webpack_public_path__ + "static/media/agsmu-sm-1.e2515313.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agsmu/agsmu-sm-1.jpg
// module id = 3376
// module chunks = 14